import script from "./Lesson.vue?vue&type=script&setup=true&lang=js"
export * from "./Lesson.vue?vue&type=script&setup=true&lang=js"

import "./style.scss?vue&type=style&index=0&id=506bcf3f&lang=scss&scoped=true"

import exportComponent from "/Users/kobayashiyasutaka/Documents/Projects/murakihp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-506bcf3f"]])

export default __exports__